/**
 * This file holds the actions/mutations types
 * For more information about why this is needed
 * check here https://vuex.vuejs.org/guide/mutations.html#using-constants-for-mutation-types
 */

export const GET_RECIPE = "GET_RECIPE";
export const SET_SAVED_RECIPE = "SET_SAVED_RECIPE";
export const SET_RECIPE_V2 = "SET_RECIPE_V2";

export const SAVE_RECIPE = "SAVE_RECIPE";

export const SET_INIT_RECIPE = "SET_INIT_RECIPE";
export const SET_DEFAULT_RECIPE = "SET_DEFAULT_RECIPE";
export const SET_RECIPE_ID = "SET_RECIPE_ID";

export const UPDATE_RECIPE_COMPONENT = "UPDATE_RECIPE_COMPONENT";
export const UPDATE_UGC = "UPDATE_UGC";
export const SAVE_PERSONALIZATION = "SAVE_PERSONALIZATION";
export const REMOVE_PERSONALIZATION = "REMOVE_PERSONALIZATION";

export const REMOVE_COMPONENT = "REMOVE_COMPONENT";
export const CREATE_COMPONENT = "CREATE_COMPONENT";
export const UPDATE_COMPONENT = "UPDATE_COMPONENT";

export const REMOVE_COMPONENT_PROPERTY = "REMOVE_COMPONENT_PROPERTY";
export const CHECK_MODERATION = "CHECK_MODERATION";

export const SET_INVALID_UGC_COMPONENTS = "SET_INVALID_UGC_COMPONENTS";

export const SET_SUBCOMPONENT_TOOLKIT = "SET_SUBCOMPONENT_TOOLKIT";

